export default __webpack_public_path__ + "static/media/Rectangle 21.050cdc6d.png";